export const TOUR_IN_PROGRESS_STATE = 'in_progress'
export const TOUR_DELIVERED_STATE = 'delivered'
export const TOUR_WAITING_STATE = 'waiting'
export const TOUR_DELIVERY_ACTION = 'L'
export const TOUR_COLLECT_ACTION = 'C'

export const STEP_IN_PROGRESS_STATE = 'in_progress';
export const STEP_DELAYED_STATE = 'delayed';
export const STEP_NON_BLOCKING_ANOMALY_STATE = 'non_blocking_anomaly';
export const STEP_BLOCKING_ANOMALY_STATE = 'blocking_anomaly';
export const STEP_COMPLETED_STATE = 'completed';

export const LOADING_IN_PROGRESS_STATE = 'in_progress';
export const LOADING_NON_BLOCKING_ANOMALY = 'non_blocking_anomaly';
export const LOADING_COMPLETED_STATE = 'completed';

export const ROLE_ADMIN = 'ADMIN';
export const ROLE_SUPER_ADMIN = 'ADMIN_PU';
export const ROLE_USER = 'USER';
